// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "global." + {"247":"aa52307dfce6b1ddc201","301":"63118f5074979e3d483c"}[chunkId] + ".js";
};